import React, { useContext, useEffect, useState } from 'react';
import { DataTableComponent } from '../../components/data-table/data-table.component';
import { TasksContext } from '../../store';
import { MapperService } from '../../services/mapper/mapper.service';
import { TasksService } from '../../services/tasks/tasks.service';

export default function TasksContent(props: any) {
  const {columns, mode, options, setViewMode, sort, pagination, paginate, search, setBuilding, setTasks, tasks, tasksCache, activeFilters, setFilters} = useContext(TasksContext);
  const { buildingId } = props;

  const mapperService = new MapperService();
  const tasksService = new TasksService();

  const emptyArr: any = [];

  const [loading, setLoading] = useState(true);

  const toggleView = () => {
    const viewMode = mode === 'table' ? 'calendar' : 'table';
    setViewMode(viewMode);
  }

  async function getLogs() {
    setTasks(emptyArr);
    setLoading(true);
    const buildingWithTasks = await tasksService.listTasksByBuildingId(buildingId);
    const { name, employees } = buildingWithTasks;
    const { allTasks, filters } = await mapperService.tasks(employees, activeFilters);
    setFilters(filters);
    setBuilding(name);
    setTasks(allTasks);
    setLoading(false);
  }

  useEffect(() => {
    getLogs();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getLogs();
    // eslint-disable-next-line
  }, [activeFilters]);

  const sortTable = (fieldName: string, sortDirection: string) => {
    const params = {fieldName, sortDirection};
    return sort(params);
  }

  const searchTable = (fieldName: string, searchString: string) => {
    const params = {fieldName, searchString}
    return search(params);
  }

  return (
    <DataTableComponent
      columns={columns}
      data={tasks}
      allData={tasksCache}
      mode={mode}
      options={options}
      toggleView={toggleView}
      refresh={getLogs}
      sort={sortTable}
      search={searchTable}
      loading={loading}
      pagination={pagination}
      paginate={paginate}
      total={tasksCache?.length || 0}
      title='tasks'
    />
  );
}
